import { AlertBox, Icon } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import messages from './BusinessBankStatementTrueLayer.messages';
import styles from '../../AlertBoxes.module.css';

export const TrueLayerAlertBox = ({ status }: { status: string | null }) => {
    if (status === 'success') {
        return (
            <AlertBox
                variant={status}
                className={styles.alertBox}
                data-testid="alertbox">
                <Icon
                    width={20}
                    height={20}
                    fill={'var(--color-success-drk)'}
                    icon="checkCircleFilled"
                    className={styles.successAlertBoxIcon}
                />
                <div className={styles.text}>
                    <FormattedMessage {...messages.trueLayerSuccess} />
                </div>
            </AlertBox>
        );
    }
    if (status === 'cancel') {
        return (
            <AlertBox
                variant={status}
                className={styles.alertBox}
                data-testid="alertbox">
                <Icon
                    fill={'var(--color-error)'}
                    width={20}
                    height={20}
                    icon="banOutline"
                    className={styles.cancelAlertBoxIcon}
                />
                <div className={styles.text}>
                    <FormattedMessage {...messages.trueLayerNoPermission} />
                </div>
            </AlertBox>
        );
    }

    return (
        <AlertBox
            variant="failure"
            className={styles.alertBox}
            data-testid="alertbox">
            <Icon
                width={20}
                height={20}
                icon="exclamationTriangleOutline"
                className={styles.failureAlertBoxIcon}
                fill={'var(--color-error)'}
            />

            <div className={styles.text}>
                <FormattedMessage {...messages.trueLayererror} />
            </div>
        </AlertBox>
    );
};

export default TrueLayerAlertBox;
